export default __webpack_public_path__ + "static/media/annex2.5735e215.png";